export enum PriceTypes {
  OLD,
  TOTAL,
  CURRENT,
  SELECTED,
  NEW,
  DISCOUNT,
}
